import { useState } from 'react';
import { fetchAdmins } from '../utils/apiCalls';
import OnboardAdmin from './OnboardAdmin';
import UserInfo from './UserInfo';

export default function ClinicAdmins({clinicId, token, user }) {
    const [clinicAdmins, setClinicAdmins] = useState({});
    const [openAdminList, setOpenAdminList] = useState({});
    const [openAddAdmin, setOpenAddAdmin] = useState(false);
    const [currentAdmin, setCurrentAdmin] = useState(null);
    const [showAdminModal, setShowAdminModal] = useState(null);
    const [loadingAdmins, setLoadingAdmins] = useState(false);
    const [showInactive, setShowInactive] = useState(false);

    const loadAdmins = async(clinicId) => {
        try {
            if (openAdminList[clinicId]) {
                setOpenAdminList(prev => ({ ...prev, [clinicId]: false}));
                return;
            }

            setLoadingAdmins(true)

            if (!clinicAdmins[clinicId]) {
                const admins = await fetchAdmins(clinicId, token);
                setClinicAdmins(prev => ({...prev, [clinicId]: admins}));
            }
            setOpenAdminList(prev => ({ ...prev, [clinicId]: true}));
        } catch (error) {
            console.error('Error loading admins for this clinic', error);
        } finally {
            setLoadingAdmins(false);
        }
    };

    const refreshAdmins = async(clinicId) => {
        try {
            const admins = await fetchAdmins(clinicId, token);
            setClinicAdmins(prev => ({...prev, [clinicId]: admins}));
        } catch (error) {
            console.error('Error refreshing admin users', error);
        }
    };

    const openAdminModal = (admin) => {
        setShowAdminModal(true);
        setCurrentAdmin(admin);
    }

    const activeAdmins = clinicAdmins[clinicId]?.filter(admin => admin.is_active) || [];
    const inactiveAdmins = clinicAdmins[clinicId]?.filter(admin => !admin.is_active) || [];

    return (
        <div className='rounded-2xl border border-slate-200 bg-white/70 backdrop-blur p-5 shadow-sm'>
            <div className='flex items-center justify-between mb-4'>
                <h3 className='text-sm font-semibold tracking-wide text-slate-600'>clinic admins</h3>
                <button onClick={() => loadAdmins(clinicId)} className='px-6 py-3 mt-4 rounded-lg text-white font-bold text-xs voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow transition'>
                    {openAdminList[clinicId] ? 'hide' : 'view clinic admins'}
                </button>
            </div>

            {/* toggle inactive  */}
            {openAdminList[clinicId] && inactiveAdmins.length > 0 && (
                <div className='mb-3'>
                    <button onClick={() => setShowInactive(prev => !prev)} className='text-xs text-slate-500 hover:text-docpgrPurple transition'>
                        {showInactive ? `Hide inactive (${inactiveAdmins.length})` : `Show inactive (${inactiveAdmins.length})`}
                    </button>
                </div>
            )}

            {/* admin list  */}
            {openAdminList[clinicId] && (
                <div className='space-y-3'>
                    {loadingAdmins && (
                        <p className='text-sm text-slate-500'>
                            loading admins...
                        </p>
                    )}

                    {!loadingAdmins && activeAdmins.length === 0 && (
                        <p className='text-sm text-slate-500'>
                            no active admins for this clinic
                        </p>
                    )}

                    {/* active admins  */}
                    {activeAdmins.map(admin => (
                        <div key={admin.user_id} onClick={() => openAdminModal(admin)} className='flex items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm hover:border-docpgrPurple hover:shadow-docpgr-purple-glow cursor-pointer transition'>
                            <div>
                                <p className='text-sm font-semibold text-slate-800'>
                                    {admin.full_name}
                                </p>
                                <p className='text-xs text-slate-500'>
                                    clinic admin
                                </p>
                            </div>
                        </div>
                    ))}

                    {/* inactive admins  */}
                    {showInactive && inactiveAdmins.map(admin => (
                        <div key={admin.user_id} onClick={() => openAdminModal(admin)} className='flex items-center justify-between rounded-lg border border-slate-200 bg-slate-50 px-4 py-3 shadow-sm opacity-70 hover:opacity-100 hover:border-docpgrPurple hover:shadow-docpgr-purple-glow cursor-pointer transition'>
                            <div>
                                <p className='text-sm font-semibold text-slate-800'>
                                    {admin.full_name}
                                </p>
                                <p className='text-xs text-slate-500'>
                                    deactivated admin
                                </p>

                                <span className='text-[10px] uppercase font-semibold text-slate-500 border border-slate-300 px-2 py-0.5 rounded'>deactivated</span>
                            </div>
                        </div>
                    ))}
                    
                    <button onClick={() => setOpenAddAdmin(true)} className='mt-4 px-4 py-2 rounded-lg text-white font-bold text-xs voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow transition'>
                        + add clinic admin
                    </button>
                </div>

            )}

            {showAdminModal && (
                <UserInfo user={currentAdmin} setCloseModal={setShowAdminModal} refreshUsers={refreshAdmins} clinicId={clinicId} />
            )} 

            {openAddAdmin && (
                <OnboardAdmin isOpen={openAddAdmin} onClose={() => setOpenAddAdmin(false)} clinicId={clinicId} token={token} onSuccess={() => refreshAdmins(clinicId)} />
            )}
        </div>
    )
}